/**
 * Environment detection utility
 * Provides robust environment checking for all application modules
 */
export function isProdEnvironment(): boolean {
  return import.meta.env.MODE === 'production';
}

const BETA_SUB_DOMAIN = '.beta.letrus.com.br';

export const isBetaDomain = window.location.origin.includes(BETA_SUB_DOMAIN);
